import { PhotoAndCaption } from "api/getPhotoAndCaptions";
import styles from "./style.module.css";

export function Photos({
  title,
  photoAndCaptionPairs,
}: {
  title: string;
  photoAndCaptionPairs: PhotoAndCaption[];
}) {
  const chunks = chunk(photoAndCaptionPairs, 4);
  return (
    <div className="mt-2">
      <h3>{title}</h3>
      <div>
        {chunks.map((chunk, index) => {
          return (
            <div key={`chunk-${index} ${chunk.length}`} className="mt-2">
              {chunk.map((photoAndType, index) => {
                const photoPath =
                  photoAndType.photo.thumbnailPath ??
                  photoAndType.photo.originalPath;
                if (!photoPath) return null;

                return (
                  <div
                    className="d-inline-block"
                    key={`photo-${index} ${photoAndType?.photo?.id}`}
                    style={{
                      pageBreakInside: "avoid",
                      breakInside: "avoid",
                      width: "25%",
                    }}
                  >
                    <div style={{ height: "2.5rem" }}>
                      {photoAndType.caption}
                    </div>
                    <div
                      className={styles.imgContainer}
                      key={`image-${index}-${photoAndType.photo?.id} border-light`}
                    >
                      <img
                        className={`${styles.imgThumbnail} img-thumbnail`}
                        src={photoPath}
                        alt=""
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function chunk<T>(arr: Array<T>, len) {
  const chunks = [] as Array<Array<T>>;
  let i = 0;
  let n = arr.length;

  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }

  return chunks;
}
